@if (isVisible()) {
  <section
    class="fixed inset-x-0 bottom-0 z-[90] px-4 pb-4"
    [attr.aria-label]="COOKIE_CONSENT_TEXT.ariaLabel"
    data-testid="cookie-consent-banner"
  >
    <div
      class="mx-auto flex w-full max-w-4xl flex-col gap-4 rounded-2xl border border-brand-border bg-brand-white p-5 shadow-2xl md:flex-row md:items-center md:justify-between"
    >
      <div class="md:pr-6">
        <h2 class="m-0 text-base font-bold text-brand-black">
          {{ COOKIE_CONSENT_TEXT.title }}
        </h2>
        <p class="mt-1 text-sm text-brand-gray">
          {{ COOKIE_CONSENT_TEXT.message }}
        </p>
      </div>
      <div class="flex shrink-0 flex-col gap-3 sm:flex-row">
        <button
          type="button"
          class="w-full cursor-pointer rounded-lg border border-brand-border bg-brand-white px-5 py-2.5 text-sm font-semibold text-brand-black hover:bg-brand-gray/5 sm:w-auto"
          (click)="onDecline()"
          data-testid="cookie-consent-decline"
        >
          {{ COOKIE_CONSENT_TEXT.declineLabel }}
        </button>
        <button
          type="button"
          class="w-full cursor-pointer rounded-lg bg-brand-primary px-5 py-2.5 text-sm font-semibold text-white hover:opacity-90 sm:w-auto"
          (click)="onAccept()"
          data-testid="cookie-consent-accept"
        >
          {{ COOKIE_CONSENT_TEXT.acceptLabel }}
        </button>
      </div>
    </div>
  </section>
}
